import videojs from 'video.js';
import { DotLottie } from '@lottiefiles/dotlottie-web';

$(document).ready(function () {
    const sectionObj = $('.hero-type-6');

    if (sectionObj.hasClass('-video')) {

        const lottieCanvasBox = $('#dotlottie-canvas');
        const lottieCanvas = lottieCanvasBox.find('canvas');
        const imageBox = $('.hero-type-6 .image-box');
        const videoBox = $('.hero-type-6 .video-box');
        const contentBox = $('.hero-type-6 .content-box');
        const video = $('.video-box video');
        let durationLimit = parseFloat(sectionObj.data('duration')) || 0;
        const shouldLoop = String(sectionObj.data('loop')) === '1' || sectionObj.data('loop') === true; // custom loop flag

        if (lottieCanvas.length > 0) {
            const lottieSrc = lottieCanvas.data('src');
            const lottieLoop = lottieCanvas.data('loop');

            const dotLottie = new DotLottie({
                autoplay: true,
                loop: lottieLoop,
                canvas: lottieCanvas[0],
                src: lottieSrc
            });

            dotLottie.addEventListener('load', () => {
                // If durationLimit > 0 we stop and hide lottie after timer; if 0 — let it play fully.
                if (durationLimit > 0 && !lottieLoop) {
                    setTimeout(() => {
                        dotLottie.stop();
                        lottieCanvasBox.addClass('-hide');
                        if (imageBox.length > 0) {
                            imageBox.addClass('-show');
                        }
                        contentBox.addClass('-show');
                    }, durationLimit * 1000);
                } else {
                    // Reveal content but keep lottie visible; no stopping.
                    contentBox.addClass('-show');
                }
            });
        }

        if ($('#video-js-hero').length > 0) {
            let videoHero = videojs('#video-js-hero', {
                muted: true,
                preload: 'auto',
                autoplay: 'muted',
                playsinline: true,
                loop: shouldLoop && durationLimit === 0,
                controls: false,
                userActions: {
                    hotkeys: false,
                    doubleClick: false
                }
            });

            video[0].play().catch(error => {
                console.error('error:', error);
            });

            videoHero.on('loadedmetadata', function () {
                const videoDuration = videoHero.duration();
                const playbackLimit = Math.min(videoDuration, durationLimit);
                const epsilon = 0.04; // avoid float drift

                const onTimeUpdate = function () {
                    // Custom loop only when loop enabled, durationLimit > 0 and shorter than real duration
                    if (shouldLoop && durationLimit > 0 && videoDuration > durationLimit) {
                        if (videoHero.currentTime() >= playbackLimit - epsilon) {
                            videoHero.currentTime(0);
                        }
                        return;
                    }

                    // Original stop behavior (only if durationLimit > 0)
                    if (durationLimit > 0 && videoHero.currentTime() >= playbackLimit) {
                        videoHero.pause();
                        videoHero.off('timeupdate', onTimeUpdate);
                    }
                };

                videoHero.on('timeupdate', onTimeUpdate);
            });

            if (durationLimit > 0) {
                setTimeout(function () {
                    if (imageBox.length > 0) {
                        videoBox.addClass('-hide');
                        imageBox.addClass('-show');
                    }
                    contentBox.addClass('-show');
                }, durationLimit * 1000);
            } else {
                // durationLimit === 0: play fully; do NOT hide video or swap to image
                contentBox.addClass('-show');
            }
        } else if (lottieCanvas.length === 0) {
            if (imageBox.length > 0) {
                imageBox.addClass('-show');
            }
            contentBox.addClass('-show');
        }
    }
});